<template>
  <div class="modal" @keydown.enter="handleEnterKey" @keydown.esc="$emit('close')">
    <div class="modal-content">
      <div class="modal-header">
        <h1>Edit site</h1>
        <button type="button" class="btn-close" data-bs-dismiss="modal" @click="$emit('close')"
                aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <form @submit.prevent="saveSite">
          <div class="mb-3">
            <label for="code" class="form-label">Code</label>
            <input type="text" v-model="siteData.code" id="code" ref="inputCode" class="form-control" required>
            <div v-if="siteCodeError" class="text-danger">{{ siteCodeError }}</div>
          </div>
          <div class="mb-3">
            <label for="name" class="form-label>">Name</label>
            <input type="text" v-model="siteData.name" id="name" class="form-control" required>
            <div v-if="siteNameError" class="text-danger">{{ siteNameError }}</div>
          </div>
        </form>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" @click="$emit('close')">Cancel</button>
        <button type="button" class="btn btn-primary" @click="saveSite" :disabled="isSaveButtonDisabled">Save changes
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import {
  checkSiteCodeUnique,
  checkSiteNameUnique
} from "@/utils/mycrew_functions";

export default {
  name: 'EditSiteModal',
  props: {
    site: {
      type: Object,
      required: true,
    },
    organisation: {
      type: Object,
      required: true,
    },
  },
  mounted() {
    this.$refs.inputCode.focus();
    this.initializeSiteData();
  },
  data() {
    return {
      siteData: {},
      siteCodeError: '',
      siteNameError: '',
      initialSiteCode: '',
      initialSiteName: '',
    };
  },
  computed: {
    isSaveButtonDisabled() {
      return this.siteData.code === '' ||
          this.siteData.name === '' ||
          this.siteCodeError !== '' ||
          this.siteNameError !== '';
    },
  },
  watch: {
    site: {
      immediate: true,
      handler(newVal) {
        this.siteData = {...newVal};
        this.initialSiteCode = newVal.code;
        this.initialSiteName = newVal.name;
      },
    },
    'siteData.code': async function (newCode, oldCode) {
      if (newCode !== oldCode && newCode !== this.initialSiteCode) {
        const result = await checkSiteCodeUnique(this.organisation.slug, newCode);
        if (result.status === 'unique') {
          this.siteCodeError = '';
        } else {
          this.siteCodeError = 'Site code is not unique for this organisation';
        }
      } else {
        this.siteCodeError = '';
      }
    },
    'siteData.name': async function (newName, oldName) {
      if (newName !== oldName && newName !== this.initialSiteName) {
        const result = await checkSiteNameUnique(this.organisation.slug, newName);
        if (result.status === 'unique') {
          this.siteNameError = '';
        } else {
          this.siteNameError = 'Event name is not unique for this organisation';
        }
      } else {
        this.siteNameError = '';
      }
    },
  },
  methods: {
    async saveSite() {
      this.$emit('save-site', this.siteData);
    },
    handleEnterKey() {
      if (!this.isSaveButtonDisabled) {
        this.saveSite();
      }
    },
    initializeSiteData() {
      this.siteData = {...this.site};
      this.initialSiteCode = this.site.code;
      this.initialSiteName = this.site.name;
    },
  },
};
</script>

<style scoped>
.modal {
  display: block;
  position: fixed;
  z-index: 1;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgb(0, 0, 0);
  background-color: rgba(0, 0, 0, 0.4);
}

.modal-content {
  background-color: #fefefe;
  margin: 15% auto;
  padding: 20px;
  border: 1px solid #888;
  width: 80%;
}

.close {
  color: #aaa;
  float: right;
  font-size: 28px;
  font-weight: bold;
}

.close:hover,
.close:focus {
  color: black;
  text-decoration: none;
  cursor: pointer;
}
</style>